import type { FaireProductEntity } from "../../entity_types/product";

export const p_8wrdkrht8c: FaireProductEntity = {
  token: "p_8wrdkrht8c",
  type: "product",
  name: "Endless Summer Card",
  brandName: "Paradise Now Hawai\u02bbi",
  imageUrl:
    "https://cdn.faire.com/fastly/08201a324dd339f371eefbbcc65c5844c56d3727f72dfe9ffdf3768bd90453a3.jpeg",
  priceDollars: 2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/d13757ace51570cc8baeba61cd04fb1b9a43b4d5fc9e44e080c747633f264354.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
